import _, { values } from "lodash";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Sheet from "react-modal-sheet";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Afribrand from "../../../assets/images/afriglobal.svg";
import ArrowDown from "../../../assets/images/arrowDown.svg";
import Bulb from "../../../assets/images/bulb.svg";
import CartIcon from "../../../assets/images/cartIcon.svg";
import Clinixbrand from "../../../assets/images/clinix.svg";
import DisableRight from "../../../assets/images/DisableRight.svg";
import Dnabrand from "../../../assets/images/dna.svg";
import Docbrand from "../../../assets/images/docbrand.svg";
import arivealive from "../../../assets/images/arivealive.png";
import broadplace from "../../../assets/images/broadplaces.png";
import Echobrand from "../../../assets/images/echo.svg";
import Homeicon from "../../../assets/images/homeIcon.svg";
import Imagebrand from "../../../assets/images/imag.svg";
import InfoIcon from "../../../assets/images/infoIcon.svg";
import Lancetbrand from "../../../assets/images/lancet.svg";
import Backicon from "../../../assets/images/mobback.svg";
import NavRight from "../../../assets/images/navRight.svg";
import Closeicon from "../../../assets/images/SheetClose.svg";
import Synlabbrand from "../../../assets/images/synlab.svg";
import TotalCard from "../../../assets/images/totalCard.svg";
import Unionbrand from "../../../assets/images/union.svg";
import { SliderComponent, Toast } from "../../../components";
import ChangeLocation from "../../../components/change-location/ChangeLocation";
import PricecardComponent from "../../../components/priceCompareCard";
import Layout from "../../../layout";
import { clearTest } from "../../../redux/auth/actions";
import axios from "../../../redux/axios";
import { clearCart } from "../../../redux/cart/CartAction";
import { api } from "../../../utils/constants";
import AddRecipient from "../../AddRecipient";
import PartnerPop from "./components/diagnosticPartnerPop";
import SelectedPop from "./components/partnerSelectedPop";
import idea from "./../../../../src/assets/images/idea 2.svg";
import "./styles.scss";
import { Helmet } from "react-helmet";
import { getFirebaseAnalyticsInstance } from "../../../firebase";
import ReactGA from 'react-ga';
import DelIcon from "../../../assets/images/delIcon.svg";

const count = [
  { id: "11" },
  { id: "22" },
  { id: "33" },
  { id: "44" },
  { id: "55" },
  { id: "65" },
];
const countTwo = [{ id: "1" }, { id: "2" }, { id: "3" }];
const countThree = [{ id: "1" }, { id: "2" }];

const apiData = {
  data: [
    {
      test_type: "pathology",
      testname_uuid: "LP-B47D8FD1",
      areaRef: "AR-35271B1F",
    },
    {
      test_type: "radiology",
      testname_uuid: "LR-74C1ABD3",
      areaRef: "AR-35271B1F",
    },
    {
      test_type: "pathology",
      testname_uuid: "LP-B708639F",
      areaRef: "AR-35271B1F",
    },
  ],
  homeservice: "yes",
};
const PriceCompare = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [recipientPopup, setRecepientPopup] = useState(false);
  const [locations, setLocations] = useState([]);
  const [locationSave, setLocationSave] = useState(false);
  const [labOptionSelect, setLabOptionSelect] = useState(false);
  const [labOptionVal, setLabOptionVal] = useState([]);
  const [homeSelection, setHomeSelection] = useState([]);
  const [nohomeSelection, setNoHomeSelection] = useState(false);
  const [locationChange, setLocationChange] = useState(false);
  const [locationChangeError, setLocationChangeError] = useState(false);
  const [selectedTestCountMobile, setSelectedTestCountMobile] = useState(false);
  const [addcartAlert, SetAddcartAlert] = useState(false);
  const [homeserviceStatus, setHomeserviceStatus] = useState(false);
  const [homeAvailable, setHomeAvailable] = useState(false)
  const [data, setData] = React.useState([
    "Lagos",
    "Abuja",
    "Port-Harcourt",
    "Enugu",
    "Kaduna",
    "Kaduna",
  ]);
  const [mobileView, setMobileView] = useState(false);
  const [btmfilter, setbtmfilter] = useState(false);
  const [btmcart, setbtmcart] = useState(false);
  const [partnerShow, setPartnerShow] = useState(false);
  const [cpselected, setCpselected] = useState(false);
  const [brandlist, setBrandlist] = useState([]);
  const [homeServiceArray, setHomeServiceArray] = useState([]);
  const [homeService, setHomeService] = useState(true);
  const [cheapestOption, setCheapestOption] = useState([]);
  const [update, setUpdate] = useState(false);
  const [radiovalue, setRadiovalue] = useState([]);
  const [totallab, setTotallab] = useState([]);
  const [radiotwo, setRadiotwo] = useState([]);
  const [radiothree, setRadiothree] = useState([]);
  const [countresult, setCountResult] = useState([]);
  const [result, setResult] = useState([]);
  const [checkoutdisplay, setCheckoutdisplay] = useState([]);
  const [partnername, setPartnerName] = useState("");
  const [test, setTest] = useState([]);
  const [cheapestcount, setCheapestcount] = useState([]);
  const [cheapestcounttwo, setCheapestcounttwo] = useState([]);
  const [refresh, doRefresh] = useState(0);
  const [totalamount, setTotalamount] = useState("");
  const [amountarr, setAmountarr] = useState([]);
  const [homearr, setHomearr] = useState([]);
  const [selectallcard, setSelectallcard] = useState(false);
  const [loginPop, setLoginPop] = useState(false);
  const [filteredPartner, setFilteredPartner] = useState([]);
  const [showAddressChangePopup, setAddressChangePopUp] = useState(false);
  const [selectedCardsList, setSelectedCards] = useState([]);
  const [errorToast, setErrorToast] = useState(false);
  const [partnerCounts, setPartnerCount] = useState(0);
  const [partner, setPartner] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  const handleButtonClick = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const [areaRef, setAreaRef] = useState()

  const handleAllTestsSelect = (key, partner, IsSelected) => {
    let data = selectedCardsList;

    if (data && data[Number(key)]) {
      data[Number(key)]["diagnosticspartner"] = partner;
      data[Number(key)]["key"] = key;
      data[Number(key)]["isSelected"] = IsSelected;

      setSelectedCards(data);
    }
  };

  const cityState = useSelector((state) =>
    state.city != undefined && state.city.label != undefined ? state.city : ""
  );

  const areaState = useSelector((state) =>
    state.area != undefined && state.area.area != undefined
      ? state.area.area
      : ""
  );

  console.log(areaState, cityState, "dgvsas")

  const cities = useSelector((state) => state.auth.cities);

  console.log(useSelector((state) => state.area), "scgusgdc")
  const handleChangeAddress = () => {
    window.scroll(0, 180);
    setAddressChangePopUp(true);
  };

  React.useEffect(() => {
    dispatch(clearCart());
    window.scrollTo(0, 0);
  }, []);

  const selected_test = useSelector(
    (state) => state.selected_test.selected_test
  );
  //value label
  const Cancel_Redirect = () => {
    setLocationSave(false);
  }
  const Redirect_to_add_new = () => {
    history.push({ pathname: "/populartest" });
    setAddressChangePopUp(false);
    dispatch(clearTest());
    setLocationChangeError(false);
    setLocationSave(false)
  }
  console.log(areaRef, selected_test, "dgvsas")
  const handleChangeLocation = () => {
    // areaRef.value
    if (locationChange) {
      setCountResult([])
      setRadiotwo([])
      setRadiovalue([])
      try {
        // setBrandlist([]);
        let mData =
          routeDatas && routeDatas
            ? routeDatas
            : localStorage.getItem("COMPAREPRICEDATA");

        const dat = []
        mData.data.map((item, index) => {
          dat.push({
            areaRef: areaRef.value,
            test_type: item.test_type,
            testname_uuid: item.testname_uuid
          })
        })

        console.log(mData, dat, "sjagusyg");
        let payLoad = {
          // data: _.uniqBy(mData.data, "testname_uuid"),
          data: _.uniqBy(dat, "testname_uuid"),
          homeservice: "yes",
          recommended_test: mData.recommended_test,
        };
        var config = {
          method: "post",
          url: api.compareprice_get,
          headers: {
            "Content-Type": "application/json",
          },
          data: payLoad,
        };
        axios(config)
          .then(function (response) {
            setCountResult([])
            apiFetch();
            if (response.data.status === "Success") {
              if (response.data.data.length > 0) {
                setErrorToast(false);
              } else {
                // setErrorToast(true);
                setLocationSave(true)
                // dispatch(clearTest());
              }
              console.log(response.data, "brandlist 3")

              setBrandlist(response.data);
              if (
                response.data.cheapestprice != undefined &&
                response.data.cheapestprice.length > 0
              ) {
                setCheapestOption(response.data.cheapestprice);
              }
              if (
                response.data.homeservice != undefined &&
                response.data.homeservice.length > 0
              ) {
                setHomeServiceArray(response.data.homeservice);
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
      // selected_test.map((item) => {
      //   if(item.doc.city === areaRef.label && item.doc.areaRef === areaRef.value){
      //     setAddressChangePopUp(false);
      //     setLocationChangeError(false);
      //     setLocationSave(false)
      //   }
      //   else{
      //     setLocationSave(true)
      //     // alert('Selected Tests Not Avaialble for This Location')
      //   }
      // })
      {/*........................*/ }
      // history.push({ pathname: "/populartest" });
      // setAddressChangePopUp(false);
      // dispatch(clearTest());
      // setLocationChangeError(false);
    } else {
      setLocationChangeError(true);
    }
  };

  const userid = useSelector((state) =>
    state.auth.uuid ? state.auth.uuid : ""
  );

  const routeDatas = history.location.state;

  console.log(routeDatas, "routeDatas");

  localStorage.setItem("COMPAREPRICEDATA", JSON.stringify(routeDatas));

  const selectallFn = async (e) => {
    setLabOptionSelect(e.target.checked);
    let temp = [];
    if (e.target.checked) {
      temp = cheapestOption;
    }
    console.log(cheapestOption);
    setLabOptionVal(temp);

    for (let i in temp) {
      handleRadio(temp[i].uuid, temp[i], "Yes");
    }
  };

  let da = '';
  let ty = '';

  let mData1 =
    routeDatas && routeDatas
      ? routeDatas
      : localStorage.getItem("COMPAREPRICEDATA");

  mData1?.data?.map((item) => {
    da = da + item.testName + ','
    // ty = ty + ',' + item.test_type
    console.log(item, "scgfstcghbj")

  })

  console.log(mData1, "scgfstcghbj")
  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 600
        ? setMobileView(true)
        : setMobileView(false);
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);

  const handleRadio = async (id, val, cheapest) => {
    const idToRemove = id;
    if (radiovalue && JSON.stringify(radiovalue).includes(id)) {
      const filteredPeople = radiovalue.filter(
        (item) => item.uuid !== idToRemove
      );
      setRadiovalue(filteredPeople);
      setRadiotwo(filteredPeople);
      if (cheapest == "yes") {
        const filteredPeople = radiothree.filter(
          (item) => item.uuid !== idToRemove
        );
        setRadiothree(filteredPeople);
      }
      setUpdate(!update);
    } else {
      setRadiovalue([...radiovalue, val]);
      setRadiotwo([...radiotwo, val]);
      if (cheapest == "yes") {
        setRadiothree([...radiovalue, val]);
      }
      setUpdate(!update);
    }
  };

  let handleSetRadioValue = (tests, toAdd) => {
    console.log(tests, toAdd, "fvhyygfug");
    let radioData = radiovalue;
    if (toAdd) {
      let data = radiovalue.concat(tests);

      let uniq = [...new Set(data)];
      setRadiotwo(uniq);
      setRadiovalue(uniq);
    } else {
      let uniq = [...new Set(radioData)],
        uniqData = uniq;
      for (let i in tests) {
        for (let j in uniqData) {
          if (tests[i] == uniqData[j]) {
            uniqData.splice(j, 1);
            break;
          }
        }
      }
      setRadiotwo(uniqData);
      setRadiovalue(uniqData);
    }
  };

  const HomeServicehandleRadio = (id, val) => {
    const idToRemove = id;
    if (homeSelection && JSON.stringify(homeSelection).includes(idToRemove)) {
      const filteredPeople = homeSelection.filter(
        (item) => item.uuid !== idToRemove
      );
      setHomeSelection(filteredPeople);
      handleSetRadioValue([val], false);
    } else {
      setHomeSelection([...homeSelection, val]);
      handleSetRadioValue(val, true);
    }
  };

  const apiFetch = () => {
    try {
      // setCountResult([]);
      // setRadiotwo([]);
      // setBrandlist([]);
      // setRadiovalue([])
      let mData =
        routeDatas && routeDatas
          ? routeDatas
          : localStorage.getItem("COMPAREPRICEDATA");

      const dat = []
      mData.data.map((item, index) => {
        dat.push({
          areaRef: areaState && areaState.value,
          test_type: item.test_type,
          testname_uuid: item.testname_uuid
        })

      })

      console.log(mData);
      let payLoad = {
        // data: _.uniqBy(mData.data, "testname_uuid"),
        data: _.uniqBy(dat, "testname_uuid"),
        homeservice: "yes",
        recommended_test: mData.recommended_test,
      };
      var config = {
        method: "post",
        url: api.compareprice_get,
        headers: {
          "Content-Type": "application/json",
        },
        data: payLoad,
      };
      axios(config)
        .then(function (response) {
          if (response.data.status === "Success") {
            if (response.data.data.length > 0) {
              setErrorToast(false);
            } else {
              setErrorToast(true);
              dispatch(clearTest());
            }
            console.log(response.data, "brandlist 5")
            setBrandlist(response.data);
            if (
              response.data.cheapestprice != undefined &&
              response.data.cheapestprice.length > 0
            ) {
              setCheapestOption(response.data.cheapestprice);
            }
            if (
              response.data.homeservice != undefined &&
              response.data.homeservice.length > 0
            ) {
              setHomeServiceArray(response.data.homeservice);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    apiFetch();
  }, []);

  const handleLocationClose = () => {
    setPartnerShow(false);
    setbtmfilter(false);
  };

  const handleLocationCloseSelected = () => {
    setCpselected(false);
  };

  // const handleHomeService = () => {
  //   setHomeService(!homeService);
  // };

  const brandfilter = (values) => {
    handleLocationClose();

    if (values.length > 0) {
      const filterbrand = brandlist.data.filter((item) =>
        values.includes(item.diagnosticspartner)
      );
      let temp = { data: {} };
      temp.data = filterbrand;
      console.log(filterbrand, "brandlist 6")
      setBrandlist(temp);
    }
  };

  useEffect(() => {
    if (homeService === false) {
      setHomeSelection([]);
      setUpdate(!update);
    }
  }, [homeService]);

  useEffect(() => {
    let brandlistProcess = async () => {
      let temp = [];
      if (brandlist.data != undefined && brandlist.data.length > 0) {
        await brandlist.data.forEach((v) =>
          temp.push({
            diagnosticspartner: v.diagnosticspartner,
            testData: [],
            homeService: [],
          })
        );
        setCheckoutdisplay([...new Set(temp)]);
      }
    };
    brandlistProcess();
  }, [brandlist]);

  function removecartDataFromArray(arr, id, diagnosticspartner) {
    console.log(checkoutdisplay, id, "checkDelete")
    arr.map((item, index) => {
      if (item?.diagnosticspartner === diagnosticspartner) {

        if (arr[index].hasOwnProperty("testData")) {
          // Remove the object from the "testData" array
          arr[index].testData = checkoutdisplay[index].testData.filter(obj => obj.uuid !== id);
          // setCheckoutdisplay(checkoutdisplay)
          let display = arr;
          setCheckoutdisplay(arr)
        }
      }

    })
    console.log(checkoutdisplay, "checkoutdisplay112")
    setStatusChange(!statusChnage)
    return checkoutdisplay;
  }

  function removeHomesampleArray(arr, id, diagnosticspartner) {
    arr.map((item, index) => {
      if (item?.diagnosticspartner === diagnosticspartner) {

        if (arr[index].hasOwnProperty("homeService")) {
          // Remove the object from the "testData" array
          arr[index].homeService = checkoutdisplay[index].homeService.filter(obj => obj.uuid !== id);
          // setCheckoutdisplay(checkoutdisplay)
          let display = arr;
          setCheckoutdisplay(arr)
        }
      }

    })
    console.log(checkoutdisplay, "checkoutdisplay112")
    setStatusChange(!statusChnage)
    return checkoutdisplay;
  }

  const [statusChnage, setStatusChange] = useState(false)
  console.log(checkoutdisplay, "checkoutdisplay11")

  useEffect(() => {
    setCheckoutdisplay(checkoutdisplay)

  }, [statusChnage])

  useEffect(() => {
    let process = async () => {
      setSelectedCards([]);
      let allCards = [];
      if (brandlist.data !== undefined && brandlist.data.length > 0) {
        allCards = await brandlist.data.map((val, ind) => {
          let cardObj = {
            diagnosticspartner: val.diagnosticspartner,
            key: ind,
            isSelected: false,
          };
          return cardObj;
        });
        setSelectedCards(allCards);
      }
    };
    process();
  }, [brandlist]);

  useEffect(() => {
    let testCountForMobile = 0;
    let counter = 0;
    for (let i = 0; i <= checkoutdisplay.length - 1; i++) {
      if (checkoutdisplay[i].testData.length >= 1) {
        counter++;
      }
    }

    checkoutdisplay &&
      checkoutdisplay.map((item) => {
        if (item.testData) {
          testCountForMobile = testCountForMobile + item.testData.length;
        }
      });

    if (counter !== 0) {
      setShow(true);
    } else {
      setShow(false);
    }

    var newArray = [];
    var hometemp = [];
    checkoutdisplay.forEach(function (e) {
      e.testData.forEach(function (e1) {
        newArray.push(e1);
      });
    });
    checkoutdisplay.forEach(function (e) {
      e.homeService.forEach(function (e1) {
        hometemp.push(e1);
      });
    });
    setAmountarr(newArray);
    setHomearr(hometemp);

    setSelectedTestCountMobile(testCountForMobile);
    if (checkoutdisplay[0]?.testData?.length > 0) {
      SetAddcartAlert(true);
    }
  }, [checkoutdisplay]);

  const checkoutfn = () => {
    let testArr = [];
    checkoutdisplay.forEach(function (e) {
      e.testData.forEach((val) => {
        let des =
          homearr.length > 0 &&
          homearr.find((e) => e.diagnosticspartner === val.diagnosticspartner);

        testArr.push({
          e_uuid: "",
          uuid: val.uuid,
          lab_partner_name: val.diagnosticspartner,
          home_service_available:
            val.homeserviceavailability == "AVAILABLE"
              ? "available"
              : "notavailable",
          home_service_uuid: des !== undefined && des.uuid ? des.uuid : "",
          name: val.standardisedtestname,
          home_service_included:
            des !== undefined && des.homeserviceavailability == "AVAILABLE"
              ? "yes"
              : "no",

          isRecommendedTest:
            brandlist.recommended_test &&
              brandlist.recommended_test.test_uuid.includes(val.testname_uuid)
              ? true
              : false,
          patient_name: [
            brandlist.recommended_test &&
              brandlist.recommended_test.test_uuid.includes(val.testname_uuid)
              ? brandlist.recommended_test.patient_name
              : "",
          ],
          patient_uuid:
            brandlist.recommended_test &&
              brandlist.recommended_test.test_uuid.includes(val.testname_uuid)
              ? brandlist.recommended_test.patient_uuid
              : "",
          user_uuid: userid !== "" ? userid : "",
          doctor_uuid: "",
          booking_uuid: "",
          type: "popular",
          city_uuid: cityState.value ? cityState.value : "",
          tests: {
            city: cityState.label ? cityState.label : "",
            area: areaState.label ? areaState.label : "",
            diagnosticspartner: val.diagnosticspartner,
            productcode: val.productcode,
            testdiscipline: val.testdiscipline,
            standardisedtestname: val.standardisedtestname,
            partnerstestname: val.partnerstestname,
            homeserviceavailability: val.homeserviceavailability,
            populartestdescription: val.populartestdescription,
            populartest_y_n: val.populartest_y_n,
            labretailprice: val.labretailprice,
            doctallspurchasingprice: val.doctallspurchasingprice,
            doctallsexclusivediscountedprice:
              val.doctallsexclusivediscountedprice,
            partnerlabtat: val.partnerlabtat,
            partnerlabtatindays: val.partnerlabtatindays,
            standardiseddoctalltat: val.standardiseddoctalltat,
            testname_uuid: val.testname_uuid,
            areaRef: val.areaRef,
            uuid: val.uuid,
            city_uuid: cityState.value ? cityState.value : "",
          },
        });
      });
    });
    let submitvar = {
      instructions: " ",
      reference_id: "",
      user_uuid: userid,
      amount: totalamount,
      items: testArr,
      deliveryAddress: [],
      // recommended_test: brandlist.recommended_test
    };
    if (userid === "") {
      setLoginPop(true);
      setTimeout(() => {
        localStorage.clear();
        localStorage.setItem("COMPAREPRICEDATA", JSON.stringify(routeDatas));
        localStorage.setItem("cartItem", JSON.stringify(submitvar));
        history.push("/login");
      }, 2000);
    } else {
      var config = {
        method: "post",
        url: api.compareprice_post,
        headers: {
          "Content-Type": "application/json",
        },
        data: submitvar,
      };

      console.log(submitvar);

      axios(config)
        .then(function (response) {
          if (response.data.status == "Success") {
            // getFirebaseAnalyticsInstance().logEvent('Begins Checkout', 'Checkout')
            ReactGA.event({
              category: 'Begins Checkout',
              action: 'Begins Checkout',
              label: 'Begins Checkout',
            })
            history.push({
              pathname: "/cart-update",
              state: { realtive: null, myself: null },
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const handlePartner = () => {
    window.scroll(0, 200);
    apiFetch();
    setPartnerShow(true);
  };

  let displayTotalAmount = 0;

  if (checkoutdisplay) {
    checkoutdisplay.map((items) =>
      items.testData.map(
        (item) =>
        (displayTotalAmount =
          Number(displayTotalAmount) +
          Number(item.doctallsexclusivediscountedprice))
      )
    );
  }

  const getTotalDisplayAmount = () => {
    let amount = 0;
    if (homeService === false) {
      checkoutdisplay &&
        checkoutdisplay.map((items) => {
          items.testData.map((item) => {
            console.log(item, "item")
            if (!item.uuid.toString().startsWith("LPHS")) {
              amount += Number(Number(item.doctallsexclusivediscountedprice).toFixed())
              // amount =
              //   Number(amount) + Number(item.doctallsexclusivediscountedprice);
            }
          });
        });
    } else {
      checkoutdisplay &&
        checkoutdisplay.map((items) => {
          items.testData.map((item) => {
            console.log(item, "item")
            amount += Number(Number(item.doctallsexclusivediscountedprice).toFixed())
            // amount =
            //   Number(amount) + Number(item.doctallsexclusivediscountedprice);
          });
        });
    }

    return amount.toFixed();
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/metadata/partner/getpartner`)
      .then((res) => {
        setPartnerCount(res.data.length);
      })
      .catch((err) => console.log(err.resp));
  }, []);

  const fetchLocationList = async (partnerName) => {
    try {
      let response = await axios.get(
        `${process.env.REACT_APP_API_URL}/uploadDoc/labpartner/details?area_uuid=&city_uuid=&partner_uuid=${props.partner_uuid}`
      );
      setLocations(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (
      props.value !== undefined &&
      props.value.diagnosticspartner !== undefined
    ) {
      setPartnerName(props.value.diagnosticspartner);
      fetchLocationList(props.value.diagnosticspartner);
    }
  }, []);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/metadata/partner/getpartner`)
      .then((res) => {
        setPartner(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  var array3 = [];

  for (var i = 0; i < partner.length; i++) {
    if (partner[i].uuid === props.partner_uuid) {
      array3.push(partner[i]);

      // console.log(array3, props.partner_uuid, partner[i].uuid, "partner[i]");
    }
  }

  console.log(partner, "partner[i]000");

  // console.log(valuess.diagnosticspartner, "item.data[0]")

  const phoneNumber = "+2349010996000";
  const boldStyle = {
    fontWeight: 'bold',
    color: "#FF5C3C"
  };

  return (
    <>
      <Helmet>
        <title>Compare prices from Best Diagnostic Centres
        </title>
        <meta
          name='description'
          content='Compare prices from the best diagnostic centres around you. Shop for tests, buy at discounted rates and receive results online'
        />
      </Helmet>
      <Layout>
        <div className="price-compare-outer-container">
          {!mobileView ? (
            <div className="header-row-pc">
              <img
                src={Homeicon}
                alt="HomeImg"
                onClick={() => history.goBack()}
              />
              <img src={DisableRight} alt="Rightnav" />
              <div
                className="header-text"
                onClick={() => history.push("/populartest")}
                style={{ cursor: "pointer" }}
              >
                Diagnostic Tests
              </div>
              <img src={NavRight} alt="navRight" />
              <div className="header-text" style={{ color: "#163E8C" }}>
                Compare Prices
              </div>
            </div>
          ) : (
            <div className="header-back-row" onClick={() => history.goBack()}>
              <img src={Backicon} alt="Backicon" />
              <div className="back-text">Back</div>
            </div>
          )}
          <div className="heading-font">Compare and Select Prices</div>
          <div className="note-cont-cls">
            <div className="note-outer-cont">
              <div className="inner-text">
                <span>
                  <img src={InfoIcon} alt="infoIcon" />
                </span>
                &nbsp;You can select tests from one partner to save some money
                on Home service
              </div>
            </div>
          </div>
          <div className="sample-row">
            <div className="left-content">
              {!mobileView ? (
                <div
                  className="partner-popup-open"
                  onClick={() => {
                    window.scroll(0, 200);
                    handlePartner();
                  }}
                >
                  <div className="left-conte">
                    <div className="text-cls">Showing</div>
                    <div className="count-out">
                      <span >
                        <span style={{ color: "#fff", fontSize: "15px", fontFamily: "system-ui", fontWeight: "bolder", paddingBottom: "5px" }}> {brandlist.data !== undefined && brandlist.data.length}   </span>/
                        {partnerCounts}
                      </span>
                    </div>
                    <div className="text-cls">Partners</div>
                  </div>

                  <img src={ArrowDown} alt="ArrowDown" />
                </div>
              ) : (
                <>
                  <div
                    className="partner-popup-open"
                    onClick={() => {
                      !mobileView
                        ? setPartnerShow(!partnerShow)
                        : setbtmfilter(!btmfilter);
                    }}
                  >
                    <div className="left-conte">
                      {/* <div className="text-cls">Select Diagnostic Partner</div> */}
                      <div className="text-cls">Select Lab Partners to Compare</div>
                    </div>

                    <img src={ArrowDown} alt="ArrowDown" />
                  </div>
                  <div className="mob-details">
                    Showing comparison details for <span style={{ textDecoration: "underline" }}> <span style={{fontSize: "18px", lineHeight: "20px", fontWeight: "bold" ,fontFamily:"Visuelt Pro"}}> {brandlist.data !== undefined && brandlist.data.length
                    } </span>  of {partnerCounts}  </span> partners
                  </div>
                </>
              )}

              {/* <div className="home-sample-container-out">
                <div className="left-div">Home Sample Collection Include</div>
                <div className="right-div">
                  <input
                    class="tgl tgl-light"
                    id="homw-service-top"
                    type="checkbox"
                    onChange={handleHomeService}
                  />
                  <label class="tgl-btn" for="homw-service-top"></label>
                </div>
              </div> */}
            </div>
            {/* {!mobileView && ( */}
            <div className="right-content" onClick={handleChangeAddress} style={{ cursor: "pointer" }}>
              <div className="text-select">Selected Location</div>
              <div className="loc-container-out">
                <div className="left-cont" style={{ minWidth: "150px" }}>City:{cityState.label?.replace(/_/g, ' ')
                  ?.replace(/\w\S*/g, txt => txt?.charAt(0)?.toUpperCase() + txt?.substr(1)?.toLowerCase())} </div>
                <div className="left-cont" style={{ minWidth: "150px" }}>Area:{areaState.label?.replace(/_/g, ' ')
                  ?.replace(/\w\S*/g, txt => txt?.charAt(0)?.toUpperCase() + txt?.substr(1)?.toLowerCase()) === "Wuse Ii" ? "Wuse II" : areaState.label?.replace(/_/g, ' ')
                    ?.replace(/\w\S*/g, txt => txt?.charAt(0)?.toUpperCase() + txt?.substr(1)?.toLowerCase())}</div>
                <div className="right-cont-outer">

                  <div className="left-cls" style={{ color: "#163e8c", alignItems: "right" }}><b>EDIT</b></div>
                </div>
              </div>
            </div>
            {/* )} */}
          </div>

          <div className="note-cont-cls">
            <div className="note-outer-cont">
              <div className="inner-text">
                <span>
                  <img src={InfoIcon} alt="infoIcon" />
                </span>
                &nbsp;Explore all available partners: Scroll down to view the complete list of partners providing the selected tests in this location.
              </div>
            </div>
          </div>

          {routeDatas && routeDatas.uuidpartner && routeDatas.uuidpartner.uuidpartner !== undefined &&
            <div className="note-cont-cls-1">
              <div className="note-outer-cont">
                <div className="inner-text">
                  <span style={{ marginTop: "-20%" }}>
                    <img src={idea} alt="infoIcon" />
                  </span>
                  <div class="row">
                    <div class="col-md-12">&nbsp;&nbsp;Important Tip</div>
                    <div class="col-md-12">&nbsp;&nbsp;</div>
                    <div class="col-md-12" style={{ fontSize: "14px" }}>
                      Please note that your doctor recommended partner is
                      highlighted, if you don't see the Recommended Partner you
                      can try choosing near by location.
                    </div>
                  </div>
                  {/* &nbsp; Important Tip
                <br></br>
                &nbsp;You can select tests from one partner to save some money
                on Home service*/}
                </div>
                <br></br>
              </div>
            </div>
          }
          <div className="card-container-outer">
            <div className="card-cont">
              {brandlist.data != undefined &&
                brandlist.data.length > 0 &&
                brandlist.data.map((val, ind) => {
                  console.log(val, "valvalval");
                  let isSelected = selectedCardsList[ind]
                    ? selectedCardsList[ind]["isSelected"]
                    : false;
                  return (
                    <PricecardComponent
                      partner_uuid={val.partner_uuid}
                      diagnosticspartner={val.diagnosticspartner}
                      area_uuid={areaState.value}
                      city_uuid={cityState.value}
                      id={val.id}
                      hmId={val.id + "hm"}
                      HomeServicehandleRadio={HomeServicehandleRadio}
                      homeSelection={homeSelection}
                      value={val}
                      setHomeAvailable={setHomeAvailable}
                      brandlist={brandlist}
                      homeServiceArray={homeServiceArray}
                      homeserve11={val.data[0].homeserviceavailability === "NOT AVAILABLE" ? false : true}
                      homeserve={homeService}
                      homeserviceSelectedStatus={(event) => {
                        setHomeserviceStatus(event);
                      }}
                      ind={ind}
                      radiovalue={radiovalue}
                      setRadiovalue={handleSetRadioValue}
                      totallab={totallab}
                      setTotallab={setTotallab}
                      radiotwo={radiotwo}
                      setRadiotwo={setRadiotwo}
                      countresult={countresult}
                      setCountResult={setCountResult}
                      result={result}
                      setResult={setResult}
                      checkoutdisplay={checkoutdisplay}
                      setCheckoutdisplay={setCheckoutdisplay}
                      handleRadio={handleRadio}
                      radiothree={radiothree}
                      setCheapestcount={setCheapestcount}
                      cheapestcount={cheapestcount}
                      cheapestcounttwo={cheapestcounttwo}
                      setCheapestcounttwo={setCheapestcounttwo}
                      refresh={refresh}
                      totalamount={totalamount}
                      setTotalamount={setTotalamount}
                      amountarr={amountarr}
                      setAmountarr={amountarr}
                      homearr={homearr}
                      selectallcard={isSelected}
                      setSelectallcard={setSelectallcard}
                      handleAllTestsSelect={handleAllTestsSelect}
                      recommendedTest={brandlist.recommended_test}
                      recommendedpartneruuid={
                        routeDatas &&
                        routeDatas.uuidpartner &&
                        routeDatas.uuidpartner.uuidpartner
                      }
                    />
                  );
                })}
            </div>
            {(!mobileView && (
              <div className="right-card-outer">
                <div className="right-card-outer-top">
                  <div className="top-content">
                    <img src={Bulb} alt="Bulb" />
                    <div className="help-font" style={{fontFamily:"Visuelt Pro",fontWeight:"bold",fontSize:"16px"}}>Help Tip</div>
                  </div>
                  <div className="bottom-content">
                    {/* You can click on “edit” to edit your location and maybe get
                    better offers for the tests. */}
                    Explore all available partners: Scroll down to view the complete list of partners providing the selected tests in this location.
                  </div>
                </div>
                {show == false ? (
                  <div className="total-card-outer">
                    <div className="total-card-head-font">Total Amount</div>
                    <div className="img-cls">
                      <img src={TotalCard} alt="Totalcardimg" />
                    </div>
                    <div className="info-text">
                      You don’t have any partner or test selected yet
                    </div>
                    <div className="checkout-btn">
                      <span>Continue to Add Recipients</span>
                    </div>
                  </div>
                ) : (
                  <div className="checkout-card-outer">
                    <Toast
                      text={"Item(s) added to cart  successfully"}
                      type="success"
                      open={addcartAlert}
                      setClose={() => {
                        SetAddcartAlert(false);
                      }}
                    />
                    <div className="header-font">Cart </div>

                    {checkoutdisplay.map((valuess, ind) => {
                      let sTotal = 0;
                      console.log("checkoutdisplay valuess : ", valuess);
                      return valuess.testData.length > 0 ? (
                        <>
                          <div className="checkout-price-display" key={ind}>
                            <div className="checkout-price-display-card-out">
                              <div className="header-content-out">
                                <div className="img-cls">
                                  {console.log(valuess.diagnosticspartner, "opop")}
                                  {/* {valuess.diagnosticspartner == "SYNLAB" ? (
                                    <img src={Synlabbrand} alt="Synlabbrand" />
                                  ) : valuess.diagnosticspartner ==
                                    "ECHOLAB" ? (
                                    <img src={Echobrand} alt="Echobrand" />
                                  ) : valuess.diagnosticspartner ==
                                    "UNION DIAGNOSTICS" ? (
                                    <img src={Unionbrand} alt="Unionbrand" />
                                  ) : valuess.diagnosticspartner ==
                                    "IMAGE DIAGNOSTICS" ? (
                                    <img src={Imagebrand} alt="Imagebrand" />
                                  ) : valuess.diagnosticspartner ==
                                    "DNA LABS" ? (
                                    <img src={Dnabrand} alt="Dnabrand" />
                                  ) : valuess.diagnosticspartner == "CLINIX" ? (
                                    <img src={Clinixbrand} alt="Clinixbrand" />
                                  ) : valuess.diagnosticspartner ==
                                    "CLINA LANCET" ? (
                                    <img src={Lancetbrand} alt="Lancetbrand" />
                                  ) : valuess.diagnosticspartner ==
                                    "AFRIGLOBAL" ? (
                                    <img src={Afribrand} alt="Afribrand" />
                                  ) : valuess.diagnosticspartner ==
                                    "DOCTALL" ? (
                                    <img src={Docbrand} alt="Docbrand" />
                                  ) : 
                                    valuess.diagnosticspartner == "BROADPLACES" ?(
                                      <img src={arivealive} alt="arivealive" />
                                  ):valuess.diagnosticspartner == "ARRIVE ALIVE" ? (
                                    <img src={broadplace} alt="broadplaces" />
                                  ):
                                  (
                                    <div className="heading-font-cheapest">
                                      {valuess.diagnosticspartner}
                                    </div>
                                  )} */}
                                  {partner.map((item) => {
                                    return <>
                                      {item.name === valuess.diagnosticspartner && <img src={item.logo}></img>}
                                    </>
                                  })}
                                </div>
                              </div>
                              {valuess.testData.length > 0 &&
                                valuess.testData.map((val, ind) => {
                                  if (
                                    val.standardisedtestname !==
                                    "Home Service Charge"
                                  ) {
                                    // sTotal =
                                    //   Number(sTotal) +
                                    //   Number(
                                    //     val.doctallsexclusivediscountedprice
                                    //   );
                                    sTotal += Number(Number(val.doctallsexclusivediscountedprice).toFixed())

                                    return (
                                      <div className="card-items-wrap">
                                        <div className="header-price-row row" >
                                          <div className="left-font col-md-6">
                                            {val.partnerstestname}
                                          </div>
                                          <div className="right-font col-md-4">
                                            ₦
                                            {Number(
                                              val.doctallsexclusivediscountedprice
                                            ).toFixed()}
                                          </div>
                                          <img className="col-md-2"
                                            style={{ cursor: "pointer" }}
                                            src={DelIcon}
                                            alt="DelIcon"
                                            onClick={() => removecartDataFromArray(checkoutdisplay, val.uuid, val.diagnosticspartner)}
                                          />
                                        </div>
                                        {/* <div className="divider"></div> */}
                                        {/* Delete function */}
                                        {/* <button onClick={() => removecartDataFromArray(checkoutdisplay, val.uuid, val.diagnosticspartner)}>Delete</button> */}

                                      </div>

                                    );
                                  }
                                })}
                              {homeAvailable && valuess.homeService.length > 0 &&
                                valuess.homeService.map((data, ind) => {
                                  // sTotal =
                                  //   Number(sTotal) +
                                  //   Number(
                                  //     data.doctallsexclusivediscountedprice
                                  //   );
                                  sTotal += Number(Number(data.doctallsexclusivediscountedprice).toFixed())


                                  return (
                                    <>
                                      <div className="inner-card-out">
                                        <div className="left-font">
                                          Home Service
                                        </div>
                                        <div className="right-font">
                                          (₦
                                          {data.doctallsexclusivediscountedprice})
                                        </div>
                                        <img
                                          style={{ cursor: "pointer", width: "20px" }}
                                          src={DelIcon}
                                          alt="DelIcon"
                                          onClick={() => removeHomesampleArray(checkoutdisplay, data.uuid, data.diagnosticspartner)}
                                        />
                                      </div>
                                      <div>
                                      </div>
                                    </>
                                  );
                                })}
                              {(valuess.testData.length === 1 && homeAvailable && valuess.homeService.length === 0) ?
                                ""
                                :
                                <div className="total-row-bottom">
                                  <div className="left-font">Sub Total</div>
                                  <div className="right-font">
                                    ₦{sTotal.toFixed()}
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                          {console.log(checkoutdisplay.length - 1 >= 1, "jhdfgkfdhkfhdjh")}
                          {/* {ind == checkoutdisplay.length - 1 ? ( */}
                          {/* {checkoutdisplay.length - 1 >= 1 ? ( */}

                        </>
                      ) : (
                        ""
                      );
                    })}
                    {checkoutdisplay.length >= 1 ? (
                      <div className="total-row-bottom">
                        <div className="left-font">Total Amount</div>
                        <div className="right-font">
                          ₦{getTotalDisplayAmount()}
                        </div>
                      </div>
                    ) : null}
                    <div
                      className="checkout-btn"
                      style={{ cursor: "pointer" }}
                      onClick={() => checkoutfn()}
                    >
                      <span>Continue to Add Recipients</span>
                    </div>
                  </div>
                )}
              </div>
            )) ||
              ""}
          </div>

          {!mobileView && (
            <div className="bottom-carousel-compare-price">
              <SliderComponent />
            </div>
          )}
        </div>
        {(mobileView && (
          <>
            <FloatingIcon
              onClick={() => {
                setbtmcart(true);
              }}
              count={selectedTestCountMobile}
            />
            {console.log(addcartAlert, "addcartAlert")}
            <Toast
              text={"Item(s) added to cart  successfully"}
              type="success"
              open={addcartAlert}
              setClose={() => {
                SetAddcartAlert(false);
              }}
            />
          </>
        )) ||
          ""}

        <button className="fixedButton" onClick={handleButtonClick}>

          <svg xmlns="http://www.w3.org/2000/svg" height="2em" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16" id="IconChangeColor"> <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" id="mainIconPathAttribute" fill="#ffffff"></path> </svg>
        </button>

        {/* Popup */}
        {showPopup && (
          <div className="popup">
            <p>We're here to assist you! If you have any difficulties finding tests, locating a lab, or have any questions, feel free to reach out to us on WhatsApp at <span style={{ cursor: "grab", fontWeight: "bold", color: "#ff5c3c" }}>+2349010996000</span>. Our team is ready to help you find the right diagnostic solutions and ensure a smooth experience.</p>
            <button className="popupButton" onClick={closePopup}>Close</button>
          </div>
        )}


        <Sheet
          isOpen={btmfilter}
          snapPoints={[600, 400, 100, 0]}
          onClose={() => setbtmfilter(false)}
        >
          <Sheet.Container>
            <Sheet.Header />
            <Sheet.Content>
              <PartnerPop
                resp={brandlist}
                onClose={() => {
                  setbtmfilter(false);
                }}
                view={mobileView}
                brandfilter={brandfilter}
              />
            </Sheet.Content>
          </Sheet.Container>

          <Sheet.Backdrop />
        </Sheet>
        <Sheet
          isOpen={btmcart}
          snapPoints={[800, 400, 100, 0]}
          onClose={() => setbtmcart(false)}
          scroll="yes"
          style={{ overflowY: "scroll" }}
        >
          <Sheet.Container>
            <Sheet.Header />
            <Sheet.Content scroll="yes">
              <div className="mob-right-card-outer">
                <div className="top-font">
                  <img
                    alt="icon"
                    src={Closeicon}
                    onClick={() => setbtmcart(false)}
                  />
                  Cart
                </div>
                {show == false ? (
                  <>
                    <div className="total-card-outer">
                      <div className="img-cls">
                        <img src={TotalCard} alt="Totalcardimg" />
                      </div>
                      <div className="info-text">
                        Start by adding tests to your
                        <br />
                        cart to proceed
                      </div>
                    </div>
                    <div className="checkout-btn">
                      <span>Continue to Add Recipients</span>
                    </div>
                  </>
                ) : (
                  <div className="checkout-card-outer">
                    {/* <div className="header-font">Cart </div> */}

                    {checkoutdisplay.map((valuess, ind) => {
                      let sTotal = 0;
                      return valuess.testData.length > 0 ? (
                        <>
                          <div className="checkout-price-display" key={ind}>
                            <div className="checkout-price-display-card-out">
                              <div className="header-content-out">
                                <div className="img-cls">
                                  {/* {valuess.diagnosticspartner == "SYNLAB" ? (
                                    <img src={Synlabbrand} alt="Synlabbrand" />
                                  ) : valuess.diagnosticspartner ==
                                    "ECHOLAB" ? (
                                    <img src={Echobrand} alt="Echobrand" />
                                  ) : valuess.diagnosticspartner ==
                                    "UNION DIAGNOSTICS" ? (
                                    <img src={Unionbrand} alt="Unionbrand" />
                                  ) : valuess.diagnosticspartner ==
                                    "IMAGE DIAGNOSTICS" ? (
                                    <img src={Imagebrand} alt="Imagebrand" />
                                  ) : valuess.diagnosticspartner ==
                                    "DNA LABS" ? (
                                    <img src={Dnabrand} alt="Dnabrand" />
                                  ) : valuess.diagnosticspartner == "CLINIX" ? (
                                    <img src={Clinixbrand} alt="Clinixbrand" />
                                  ) : valuess.diagnosticspartner ==
                                    "CLINA LANCET" ? (
                                    <img src={Lancetbrand} alt="Lancetbrand" />
                                  ) : valuess.diagnosticspartner ==
                                    "AFRIGLOBAL" ? (
                                    <img src={Afribrand} alt="Afribrand" />
                                  ) : valuess.diagnosticspartner ==
                                    "DOCTALL" ? (
                                    <img src={Docbrand} alt="Docbrand" />
                                  ) : valuess.diagnosticspartner == 
                                  "BROADPLACE" ?(
                                    <img src={Docbrand} alt="Docbrand" />
                                  ): valuess.diagnosticspartner == 
                                  "ARRIVE ALIVE"  ? (
                                     <img src={Docbrand} alt="Docbrand" />
                                  )
                                   :
                                   (
                                    <div className="heading-font-cheapest">
                                      {valuess.diagnosticspartner}
                                    </div>
                                  )} */}
                                  {partner.map((item) => {
                                    if (item?.name === valuess.diagnosticspartner) {
                                      return <img src={item.logo}></img>;
                                    }
                                  })}
                                </div>
                              </div>
                              {valuess.testData.length > 0 &&
                                valuess.testData.map((val, ind) => {
                                  if (
                                    val.standardisedtestname !==
                                    "Home Service Charge"
                                  ) {
                                    // sTotal =
                                    //   Number(sTotal) +
                                    //   Number(
                                    //     val.doctallsexclusivediscountedprice
                                    //   );
                                    sTotal += Number(Number(val.doctallsexclusivediscountedprice).toFixed())


                                    return (
                                      <div className="card-items-wrap">
                                        <div className="header-price-row">
                                          <div className="left-font">
                                            {val.partnerstestname}
                                          </div>
                                          <div className="right-font">
                                            ₦
                                            {Number(
                                              val.doctallsexclusivediscountedprice
                                            ).toFixed()}
                                          </div>
                                          <img className="col-md-2"
                                            style={{ cursor: "pointer" }}
                                            src={DelIcon}
                                            alt="DelIcon"
                                            onClick={() => removecartDataFromArray(checkoutdisplay, val.uuid, val.diagnosticspartner)}
                                          />
                                        </div>
                                        <div className="divider"></div>
                                      </div>
                                    );
                                  }
                                })}
                              {homeAvailable && valuess.homeService.length > 0 &&
                                valuess.homeService.map((data, ind) => {
                                  // sTotal =
                                  //   Number(sTotal) +
                                  //   Number(
                                  //     data.doctallsexclusivediscountedprice
                                  //   );
                                  sTotal += Number(Number(data.doctallsexclusivediscountedprice).toFixed())

                                  return (
                                    <div className="inner-card-out">
                                      <div className="left-font">
                                        Home Service
                                      </div>
                                      <div className="right-font">
                                        (₦
                                        {data.doctallsexclusivediscountedprice})
                                      </div>
                                      <img
                                        style={{ cursor: "pointer", width: "20px" }}
                                        src={DelIcon}
                                        alt="DelIcon"
                                        onClick={() => removeHomesampleArray(checkoutdisplay, data.uuid, data.diagnosticspartner)}
                                      />
                                    </div>
                                  );
                                })}
                              {(valuess.testData.length === 1 && homeAvailable && valuess.homeService.length === 0) ?
                                ""
                                :
                                <div className="total-row-bottom">
                                  <div className="left-font">Sub Total</div>
                                  <div className="right-font">₦{sTotal}</div>
                                </div>
                              }
                            </div>
                          </div>
                          {ind == checkoutdisplay.length - 1 ? (
                            <div className="total-row-bottom">
                              <div className="left-font">Total Amount</div>
                              <div className="right-font">
                                ₦{getTotalDisplayAmount()}
                              </div>
                            </div>
                          ) : null}
                        </>
                      ) : (
                        ""
                      );
                    })}

                    <div
                      className="checkout-btn"
                      style={{ cursor: "pointer" }}
                      onClick={() => checkoutfn()}
                    >
                      <span>Continue to Add Recipients</span>
                    </div>
                  </div>
                )}
              </div>
            </Sheet.Content>
          </Sheet.Container>



          <Sheet.Backdrop />
        </Sheet>
        <Modal show={partnerShow} onHide={handleLocationClose}>
          <PartnerPop
            resp={brandlist}
            brandfilter={brandfilter}
            close={() => setPartnerShow(false)}
            array3={array3}
          />
        </Modal>
        <Modal show={cpselected} onHide={handleLocationCloseSelected}>
          <SelectedPop />
        </Modal>
        <Toast
          text={"Please Login to Continue"}
          type="warning"
          open={loginPop}
          setClose={() => {
            setLoginPop(false);
          }}
        />

        <Toast
          text={"Please select city and area"}
          type="warning"
          open={locationChangeError}
          setClose={() => {
            setLocationChange(false);
          }}
        />

        <Toast
          text={"Added Test is not available for saved location"}
          type="warning"
          open={errorToast}
          setClose={() => {
            setErrorToast(false);
          }}
        />
      </Layout>

      <Modal
        show={showAddressChangePopup}
        onHide={() => {
          setAddressChangePopUp(false);
          setLocationChangeError(false);
        }}
        style={{ marginTop: "40px" }}
      >
        <ChangeLocation
          city={cities}
          cityState={cityState}
          areaState={areaState}
          handleChangeLocation={handleChangeLocation}
          setAreaRef={(event) => setAreaRef(event)}
          areaRef={areaRef}
          handleLocationChange={() => setLocationChange(true)}
          setAddressChangePopUp={() => setAddressChangePopUp(false)}
          setLocationChangeError={() => setLocationChangeError(false)}
        />

        <Modal.Footer></Modal.Footer>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        show={recipientPopup}
        sx={{ width: 300 }}
        size="sm"
        onHide={() => setRecepientPopup(false)}
      >
        <div className="parentContainer">
          <AddRecipient close={() => setRecepientPopup(false)} />
        </div>
      </Modal>


      {!mobileView ?
        <Modal
          backdrop="static"
          keyboard={false}
          show={locationSave}
          sx={{ width: 300 }}
          size="sm"
          onHide={() => setLocationSave(false)}
        >
          <div className="parentContainer"
            style={{
              width: "550px",
              marginTop: "40%",
              marginLeft: "10% !important",
            }}
          // style={{
          //   width: "350px",
          // }}
          >
            {/* <div>We are sorry, none of our lab Partners are providing the test <b>{da}</b> in this Location City :<b>{cityState.label}</b> and Area : <b>{areaState.label}</b></div> */}
            <div>
              We apologize for the inconvenience. The selected test(s) are currently not available in the selected location, you can try Nearby location or contact our team via WhatsApp at{''}&nbsp;&nbsp;<span style={boldStyle}>{phoneNumber}</span> &nbsp;for assistance
            </div>
            <div className="popup_btn" style={{ marginLeft: "7%", width: "33%", marginBottom: "35px" }} onClick={() => { setLocationSave(false); handleChangeAddress() }}>Proceed</div>
            <div className="popup_btn" style={{ marginLeft: "52%", width: "31%", marginTop: "-17%" }} onClick={() => setLocationSave(false)}>Close</div>
          </div>

        </Modal>
        :
        <Modal
          backdrop="static"
          keyboard={false}
          show={locationSave}
          sx={{ width: 300 }}
          size="sm"
          onHide={() => setLocationSave(false)}

        >
          <div className="parentContainer"
            // style={{
            //   width: "550px",
            //   marginTop: "40%",
            //   marginLeft: "10% !important",
            // }}
            style={{
              width: "350px",
            }}
          >
            {/* <div>We are sorry, none of our lab Partners are providing the test <b>{da}</b> in this Location City :<b>{cityState.label}</b> and Area : <b>{areaState.label}</b></div> */}
            <div>
              We apologize for the inconvenience. The selected test(s) are currently not available in the selected location, you can try Nearby location or contact our team via WhatsApp at{''}&nbsp;&nbsp;<span style={boldStyle}>{phoneNumber}</span> &nbsp;for assistance
            </div>
            <div className="popup_btn" style={{ marginLeft: "7%", width: "33%" }} onClick={() => { setLocationSave(false); handleChangeAddress() }}>Proceed</div>
            <div className="popup_btn" style={{ marginLeft: "52%", width: "31%", marginTop: "-17%%", marginTop: "-49px" }} onClick={() => setLocationSave(false)}>Close</div>
          </div>

        </Modal>
      }

    </>
  );
};
const FloatingIcon = (props) => {
  return (
    <div className="floatingIcon" onClick={() => props.onClick()}>
      <div className="count">{props.count}</div>
      <img src={CartIcon} />
      {(props.count == 0 && <div className="foverlay"></div>) || ""}
    </div>
  );
};
export default PriceCompare;
